import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { GlobalService } from '../../service/global.service';
import { HttpService } from '../../service/http.service';
import { CommonModule } from '@angular/common';
import { NgxStarsModule } from 'ngx-stars';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SeoService } from '../../service/seo.service';


declare let $: any;

/** Slug fragments that should render fully upper-cased in headings/titles. */
const SEO_ACRONYMS = new Set([
  'gst', 'itr', 'tds', 'roc', 'llp', 'iec', 'ca', 'cs', 'pan', 'msme', 'esic',
  'pf', 'ngo', 'opc', 'huf', 'dsc', 'din', 'fssai', 'ipr', 'nda', 'tan', 'din',
]);

@Component({
  selector: 'app-products',
  standalone: true,
  imports: [
    CommonModule,
    NgxStarsModule,
    RouterModule,
    FormsModule,
  ],
  templateUrl: './products.component.html',
  styleUrl: './products.component.css'
})
export class ProductsComponent implements OnInit {

  pujaList: any = {}
  pageSize: any = 1000;
  urldata: any;
  pageMainUrl: any = '';

  /** Human-readable category name derived from the URL slug (for the H1 + meta). */
  categoryTitle = 'Services';
  /** True once the products request has returned (drives the empty state). */
  loaded = false;

  constructor(private _homeService: HttpService, private route: Router,
    private _router: ActivatedRoute, public gS: GlobalService, private toastr: ToastrService,
    private seo: SeoService) {

    this._router.paramMap.subscribe(params => {
      this.urldata = this._router.snapshot.params['id'];
      this.pageMainUrl = this._router.snapshot.url[0].path;
      if (this.pageMainUrl == 'online-pooja-booking') {
        this.urldata = 'puja';
      }
      this.categoryTitle = this.prettifyCategory(this.urldata);
      this.applySeo();
      this.getData();
    });
  }
  ngOnInit(): void {

  }

  /** Turn a slug like "gst-filing" into "GST Filing" (acronyms upper-cased). */
  private prettifyCategory(slug: string): string {
    if (!slug) return 'Services';
    return slug
      .split(/[-_]/)
      .filter(Boolean)
      .map((w) => (SEO_ACRONYMS.has(w.toLowerCase()) ? w.toUpperCase() : w.charAt(0).toUpperCase() + w.slice(1)))
      .join(' ');
  }

  /** Set page-specific, keyword-rich title/description/keywords for SEO. */
  private applySeo(): void {
    const name = this.categoryTitle;
    const slug = (this.urldata || '').toLowerCase();
    this.seo.update({
      title: `${name} Services Online | LegalStack`,
      description: `Explore ${name} services online with LegalStack — verified CAs & lawyers, transparent pricing & 100% online process. Book now!`,
      keywords: `${name.toLowerCase()} online, ${slug}, ${name.toLowerCase()} services india, online ca services, legalstack`,
      service: `${name} Services`,
    });
  }

  getData() {
    // localStorage.getItem("timeZone")
    let timeZone = "Asia/Kolkata";
    this._homeService.getpujaCollections(this.urldata, timeZone, this.pageSize).subscribe((data: any) => {
      if (data?.data) {
        this.pujaList = data?.data;
      }
      this.loaded = true;
    }, (error) => {
      console.log(error);
      this.loaded = true;
    });
  }

  gotodetailspage(productUrl: string) {
    let url = '/products/' + this.urldata + '/' + productUrl
    this.route.navigate([url])
  }

  onCardClick(item: any): void {
    if (!item?.productUrl) {
      return;
    }
    this.gotodetailspage(item.productUrl);
  }

  onBookNow(item: any, event: Event): void {
    event.stopPropagation();
    if (!item?.productUrl) {
      return;
    }
    this.gotodetailspage(item.productUrl);
  }



}